import GameStepBase from '../game_step_base';
import Device from "../../../../utils/device/device";

export default class BuildFullScreenTapGameStep extends GameStepBase {
    static CLASS = 'BuildFullScreenTapGameStep';

    init(params) {
        super.init(params);
    }

    run(gameOptions) {
        if(this._shouldAllowFullScreenTap()) {
            return Promise.resolve(Object.assign(gameOptions,{fullScreenTapComponent: this.serviceFactory.componentFactoryService().createFullScreenTapComponent()}));
        } else {
            return Promise.resolve(gameOptions);
        }
    }

    _shouldAllowFullScreenTap(){
        return Device.os.isAndroid && Device.isMobileNotTablet() && !Device.hybrid.isHybrid;
    }

}
